// eslint-disable-next-line import/no-anonymous-default-export
export default {
    baseurl:'http://167.114.96.66:9005/',
}